import React, { useState } from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { ServiceImg1, ServiceImg2, ServiceImg3, ServiceImg4, ServiceImg5 } from '../../Constant/Index';
// SLick Slider Lirbaries Imported Here
import { Link } from 'react-router-dom';


const Services = () => {

    const Services = [
        {
            id: 1,
            Name: "Air Freight",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg1
        },
        {
            id: 2,
            Name: "Ocean Freight",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg2
        },
        {
            id: 3,
            Name: "Custom Brokerage",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg3
        },
        {
            id: 4,
            Name: "Warehousing ",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg4
        },
        {
            id: 5,
            Name: "Special Cargo",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg5
        },
    ];
    return (
        <>
            <Header />
            {/* Services Section Start Here */}
            <section className="services-section service-page">
                <div className="container">
                    <div className="services-list">
                        <div className="top-heading text-center mb-3">
                            <h2 className="lg-heading">Services</h2>
                        </div>
                        <div className="row align-items-center">
                            {
                                Services.map((service, index) => (
                                    <div className="col-lg-4 col-md-6 col-sm-6 col-6 mt-5 px-xl-3" key={index}>
                                        <div className="single-service">
                                            <h4 className="sm-heading">{service.Name}</h4>
                                            <div className="the-text">
                                                <p className='text crop-2-lines'>{service.Para} <Link to={"/service-detials/" + service.id} className='read-more'>Read More</Link></p>
                                            </div>
                                            <figure className="serivce-img">
                                                <img src={service.Img} alt="" className="the-img w-100" />
                                            </figure>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>
            {/* Services Section End Here */}
            {/* Footer Included Here */}
            <Footer />
            {/* Footer Included Here */}
        </>
    )
}
export default Services;